<template>
    <model-select :options="options"
                  v-model="item"
                  class="input"
                  placeholder="Select Sales Person">
    </model-select>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
export default {
   components: {
           ModelSelect
   },
   computed: {
       options() {
           let users = this.$store.getters.getProfitSectionData.managers
           let list = []

           users.forEach(function(element) {
               list.push({
                   value: element.id,
                   text: element.name
               })
           })

           return list
       },
       item: {
           get() {
               return this.$store.getters.getProfitSectionData.manager_id
           },
           set(value) {
               this.$store.dispatch('setProfitSectionFieldValue', { field: 'manager_id', value: value })

               let users = this.$store.getters.getProfitSectionData.managers

               let manager = users.find(function (element) {
                   return element.id === value
               })

               this.$store.dispatch('setProfitSectionGoalQueryFieldValue', { field: 'user_id', value: value})
               this.$store.dispatch('setProfitSectionGoalQueryFieldValue', { field: 'manager_goal', value: manager.settings.manager_goal})
           }
       }

   },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Profit/ProfitSalesPersonSelect.vue